import { Fragment, PropsWithChildren } from 'react'

import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

import ConnectedAccountsSideBarItem from '@components/ConnectedAccounts/SideBarItem'
import Breakpoint from '@components/UI/Breakpoint'
import { Hr } from '@components/UI/Hr/Hr.styled'
import { useMobileMenuControls } from '@context/MobileMenuControls'
import { PageRoutes } from '@enums'
import { useDrawer } from '@hooks/useDrawer'
import { IApplicationState } from '@store'
import { selectBrandManagerIdentitiesLink } from '@store/me'
import Theme from '@theme'
import { Container } from '@tribegroup'
import SideBarProfileMenu from './ProfileMenu'
import SideBarStyled, { SideBarFooterStyled } from './SideBar.styled'

interface IProps {
  id?: string
}

const EXCLUDE_CONNECT_ACCOUNT_FOR_ROUTES = [
  PageRoutes.BillingCampaigns,
  PageRoutes.BillingContentLibrary,
]

export const SideBar: React.FC<PropsWithChildren<IProps>> = ({ id = 'side-bar', children }) => {
  const hasBrandManagerIdentitiesLink = Boolean(
    useSelector((state: IApplicationState) => selectBrandManagerIdentitiesLink(state)),
  )
  const { open } = useMobileMenuControls()
  const { isOpen } = useDrawer()

  const { pathname } = useLocation()

  const showConnectAccount =
    hasBrandManagerIdentitiesLink &&
    EXCLUDE_CONNECT_ACCOUNT_FOR_ROUTES.findIndex((route) => pathname.includes(route)) === -1

  return (
    <Fragment>
      <SideBarStyled open={open} data-cy-element={id} data-testid="main-side-bar" expanded={isOpen}>
        <div className="scrollable-pane">{children}</div>
        <SideBarFooterStyled>
          <Container bottomOuterSpacing={0.75}>
            <Hr margin={0} color={Theme.grey400Color} />
          </Container>
          {showConnectAccount && (
            <Breakpoint tabletPortrait tabletLandscape desktop>
              <ConnectedAccountsSideBarItem />
            </Breakpoint>
          )}
          <SideBarProfileMenu />
        </SideBarFooterStyled>
      </SideBarStyled>
    </Fragment>
  )
}

export default SideBar
